<script lang="ts" setup>

	import {useI18n} from 'vue-i18n';

	const {t} = useI18n();
</script>

<template>
	<h3>
		{{ t('shoppingcart.modal.createpo.sidebar.create.title') }}
	</h3>
	<p>
		{{ t('shoppingcart.modal.createpo.sidebar.create.text') }}
	</p>
</template>
